

















































































































































































































































import { CreateElement, VNode } from 'vue';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import {
  SwTable,
  SwTableColumnSelection,
  TableColumnConfig,
  ColumnsAdjustRequestData,
  ColumnSortRequestData,
  SortedColumnInfo,
  TableEntry,
  PaginationConfig,
  PageNumberChangeRequestData,
  PageSizeChangeRequestData,
} from '@libs-uuif/shared/sw-table';
import { SwFlexLayout, FlexLayoutUnit } from '@sonicwall/unified-ui-framework/src/shared/sw-flex-layout';
import { SwToggle } from '@libs-uuif/shared/sw-toggle';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwMessageContainer } from '@libs-uuif/shared/message-service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { CustomDropdown } from '@/shared/custom-dropdown';
import { InfoState } from '@/core';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { VueRenderFunction } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import {
  SwContentToolbar,
  SwContentToolbarExpand,
  ContentToolbarExpandFilterBlock,
} from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar'; // tslint:disable-line
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwButton } from '@libs-uuif/shared/sw-button';
import ErrorLogs from '../error-logs.vue';
import ConfigurationWizard from './cw-configuration-wizard.vue';
import _ from 'lodash';

const cssPrefix = 'connectwise-manage';
const storeName = 'ConnectWiseManageStoreModule';

@Component({
  components: {
    SwFlexLayout,
    SwTable,
    SwTableColumnSelection,
    SwSelect,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwExpandableTextfield,
    SwIcon,
    SwActionBar,
    SwActionBarItem,
    SwMessageContainer,
    SwIconButton,
    SwRadio,
    SwForm,
    SwFormRow,
    CustomDropdown,
    ErrorLogs,
    ConfigurationWizard,
    SwButton,
  },
  directives: {
    tooltip,
  },
})
export default class ConnectwiseManagePage extends SwExtendedVue {
  cssPrefix = cssPrefix;

  totalBlocks: number = 4;
  blockPerLine: number = 4;
  tableLoader: boolean = false;
  disableConfigure: boolean = false;
  allData: TableEntry[] = [];
  cwCompanyOptions: any = [];
  defaultCompany: string = 'Select Company';
  defaultAgreement: string = 'Select Agreement';
  showSyncStatusMessage: boolean = false;
  syncStatusMesaage: string = '';
  initiateSync: boolean = false;
  searchTenant: string = '';
  searchBarExpanded: boolean = false;
  psaVersion: any = '';
  loadOtherApis: boolean = false;

  // below flag is used to show/hide the configuration modal
  displayConfigurationModal: boolean = false;

  // For error logs
  errorLogsList: any = [];
  errorLogsModal: boolean = false;

  // For pagination
  tempPageNumber: number = 1;
  paginationConfig: PaginationConfig = {
    pageNumber: 1,
    pageSize: 10,
  };

  // column adjust
  adjustedColumns: ColumnsAdjustRequestData = {};

  // sorting table
  sortedColumns: SortedColumnInfo[] = [];

  tempBasicData: TableEntry[] = [];
  filteredData: TableEntry[] = [];
  expandVisible: boolean = false;
  // nwAndMsspColEnabled: boolean = false;
  syncSelectValue: string = 'all';
  agreementSelectValue: string = 'all';
  networkProdSelectValue: string = 'all';
  monthlyProdSelectValue: string = 'all';

  syncFilters: any[] = [
    {
      key: 's1',
      label: this.$t('products.all')
      .toString(),
      value: 'all',
    },
    {
      key: 's2',
      label: this.$t('profile.yes')
      .toString(),
      value: 'yes',
    },
    {
      key: 's3',
      label: this.$t('profile.no')
      .toString(),
      value: 'no',
    },
  ];
  agreementFilters: any[] = [
    {
      key: 'a1',
      label: this.$t('products.all')
      .toString(),
      value: 'all',
    },
    {
      key: 'a2',
      label: this.$t('profile.yes')
      .toString(),
      value: 'yes',
    },
    {
      key: 'a3',
      label: this.$t('profile.no')
      .toString(),
      value: 'no',
    },
  ];
  networkProdsFilters: any[] = [
    {
      key: 'n1',
      label: this.$t('products.all')
      .toString(),
      value: 'all',
    },
    {
      key: 'n2',
      label: this.$t('profile.yes')
      .toString(),
      value: 'yes',
    },
    {
      key: 'n3',
      label: this.$t('profile.no')
      .toString(),
      value: 'no',
    },
  ];
  monthlyProdFilters: any[] = [
    {
      key: 'm1',
      label: this.$t('products.all')
      .toString(),
      value: 'all',
    },
    {
      key: 'm2',
      label: this.$t('profile.yes')
      .toString(),
      value: 'yes',
    },
    {
      key: 'm3',
      label: this.$t('profile.no')
      .toString(),
      value: 'no',
    },
  ];

  // tenant table columns configuration
  get tenantTableColumnsConfig(): TableColumnConfig[] {
    const tableColConfig: TableColumnConfig[] = [
      {
        key: 'tenantName',
        dataKey: 'tenantName',
        title: this.$t('userGroups.Customer')
        .toString(),
        sorter: true,
        width: 300,
      },
      {
        key: 'networkProdCount',
        dataKey: 'networkProdCount',
        title: this.$t('common.network')
        .toString(),
        sorter: true,
        render: this.renderNetworkProdCount,
      },
      {
        key: 'msspProdCount',
        dataKey: 'msspProdCount',
        title: this.$t('psaIntegration.monthly')
        .toString(),
        sorter: true,
        render: this.renderMonthlyProdCount,
      },
      {
        key: 'lastUpdated',
        dataKey: 'lastUpdated',
        title: this.$t('psaIntegration.lastUpdated')
        .toString(),
        width: 150,
      },
      {
        key: 'cwCompany',
        dataKey: 'cwCompany',
        title: this.$t('signup.compInfo')
        .toString(),
        width: 300,
        render: this.renderCompany,
      },
      {
        key: 'agreement',
        dataKey: 'agreement',
        title:  this.$t('psaIntegration.agreement')
        .toString(),
        width: 300,
        render: this.renderAgreement,
      },
      {
        key: 'syncStatus',
        dataKey: 'syncStatus',
        title: this.$t('psaIntegration.autoSync')
        .toString(),
        width: 200,
        sorter: true,
        render: this.renderSyncStatus,
      },
    ];
    return tableColConfig;
  }

  /* tslint:disable-next-line */
  renderNetworkProdCount(h: CreateElement, data: { entry: TableEntry, index: number }): VNode {
    if (data.entry.networkProdCount === '') {
      return (
        <div style={{ display: 'flex' }}>
          --
        </div>
      ) as VNode;
    }
    return (
      <div style={{ display: 'flex' }}>
        { data.entry.networkProdCount }
      </div>
    ) as VNode;
  }

  /* tslint:disable-next-line */
  renderMonthlyProdCount(h: CreateElement, data: { entry: TableEntry, index: number }): VNode {
    if (data.entry.msspProdCount === '') {
      return (
        <div style={{ display: 'flex' }}>
          --
        </div>
      ) as VNode;
    }
    return (
      <div style={{ display: 'flex' }}>
        { data.entry.msspProdCount }
      </div>
    ) as VNode;
  }
  /* tslint:disable-next-line */
  renderCompany(h: CreateElement, data: { entry: TableEntry, index: number }): VNode {
    return (
      <CustomDropdown
        dropdownLabel={data.entry.cwCompany}
        id={data.entry._key.toString()}
        key={data.entry._key.toString()}
        options={(this.cwCompanyOptions as any).companyOptions}
        limit={50}
        clearable={data.entry.cwCompany !== '' && data.entry.cwCompany !== this.defaultCompany}
        onClearSelection={() => {
          data.entry.agreement = this.defaultAgreement;
          data.entry.cwCompany = this.defaultCompany;
          data.entry.syncStatus = false;
          this.saveTenantData({ ...data.entry }, 'mapping');
        }}
        onOptionSelection={(e: string) => {
          if (data.entry.cwCompany !== e) {
            const matched: any = this.tenantsData.filter((ele:any) => (ele.cwCompany === e))
            .map((ele:any) =>  ele.tenantName); // tslint:disable-line
            if (matched !== undefined && matched.length > 0) {
              confirmService.confirm({
                status: 'major',
                message: this.renderTenantMatchMessage(matched, 'company'),
                buttons: [
                  {
                    key: 'cancel',
                    name: this.$t('common.cancel')
                    .toString(),
                  },
                  {
                    key: 'ok',
                    name: this.$t('common.confirm')
                    .toString(),
                    isDefault: true,
                  },
                ],
              })
              .then((isConfirmed: any) => {
                if (isConfirmed === 'ok') {
                  data.entry.cwCompany = e;
                  this.saveTenantData(data.entry, 'mapping');
                }
              });
            } else {
              data.entry.cwCompany = e;
              data.entry.syncStatus = true;
              this.saveTenantData(data.entry, 'mapping');
            }
          }
        }
        }
      ></CustomDropdown>
    ) as VNode;
  }
  /* tslint:disable-next-line */
  renderAgreement(h: CreateElement, data: { entry: TableEntry, index: number }): VNode { // tslint:disable-line
    let options = [];
    if (data.entry.cwCompany !== this.defaultCompany) {
      options = (this.cwCompanyOptions as any).agreementOptions ? (this.cwCompanyOptions as any).agreementOptions
      .filter((obj: any) => obj.company === data.entry.cwCompany)[0] : [];
    }
    return (
      <CustomDropdown
        dropdownLabel={data.entry.agreement}
        id={data.entry._key.toString()}
        key={data.entry._key.toString()}
        options={options ? options.agreements : []}
        limit={50}
        clearable={data.entry.agreement !== '' && data.entry.agreement !== this.defaultAgreement}
        onClearSelection={() => {
          data.entry.agreement = this.defaultAgreement;
          data.entry.syncStatus = false;
          this.saveTenantData({ ...data.entry }, 'mapping');
        }}
        onOptionSelection={(e: string) => {
          if (data.entry.agreement !== e) {
            const matched: any = this.tenantsData.filter((ele:any) => (ele.agreement === e && ele.cwCompany === data.entry.cwCompany))
            .map((ele:any) =>  ele.tenantName); // tslint:disable-line
            if (matched !== undefined && matched.length > 0) {
              confirmService.confirm({
                status: 'major',
                message: this.renderTenantMatchMessage(matched, 'agreement'),
                buttons: [
                  {
                    key: 'cancel',
                    name: this.$t('common.cancel')
                    .toString(),
                  },
                  {
                    key: 'ok',
                    name: this.$t('common.confirm')
                    .toString(),
                    isDefault: true,
                  },
                ],
              })
              .then((isConfirmed: any) => {
                if (isConfirmed === 'ok') {
                  data.entry.agreement = e;
                  data.entry.syncStatus = true;
                  this.saveTenantData(data.entry, 'mapping');
                }
              });
            } else {
              data.entry.agreement = e;
              data.entry.syncStatus = true;
              this.saveTenantData(data.entry, 'mapping');
            }
          }
        }}
      ></CustomDropdown>
    ) as VNode;
  }
  /* tslint:disable-next-line */
  renderSyncStatus(h: CreateElement, data: { entry: TableEntry, index: number }): VNode { // tslint:disable-line
    if (data.entry.syncStatus === true) {
      // eslint-disable-next-line no-mixed-operators
      if (_.isEmpty(data.entry.syncDetails) || data.entry.syncDetails.sync_status && data.entry.syncDetails.sync_status === 'success') {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SwToggle
              value={data.entry.syncStatus}
              name="basicSwitch"
              disabled={
                data.entry.cwCompany === this.defaultCompany
                || data.entry.cwCompany === ''
              }
              onChange={() => {
                data.entry.syncStatus = !data.entry.syncStatus;
                this.saveTenantData(data.entry, 'syncStatus');
              }}
            />
            <span style={{ marginLeft: '1rem' }}>
              {this.$t('psaIntegration.enabled')}
            </span>
          </div>
        ) as VNode;
      }
      return (
        <div style={{ display: 'flex' }}>
          <SwToggle
            value={data.entry.syncStatus}
            name="basicSwitch"
            disabled={
              data.entry.cwCompany === this.defaultCompany
              || data.entry.cwCompany === ''
            }
            onChange={() => {
              data.entry.syncStatus = !data.entry.syncStatus;
              this.saveTenantData(data.entry, 'syncStatus');
            }}
          />
          <span>
            <SwIcon
              style={{ marginLeft: '1.5rem' }}
              name="severity-minor"
              v-tooltip={{
                content: this.$t('psaIntegration.dattoAutotask.errorHelptext'),
                compact: true,
                placement: 'top',
              } as TooltipDirValues}
              color="#FFCC00"
            />
          </span>
          <span style={{ marginLeft: '0.5rem', fontSize: '14px' }}>
            <a onClick={ () => {
              this.errorLogsList = data.entry.syncDetails.errors;
              this.errorLogsModal = true;
            }}> { data.entry.syncDetails.error_count || '' } { this.$t('psaIntegration.errors')
            .toString() }
            </a>
          </span>
        </div>
      ) as VNode;
    }
    if (data.entry.cwCompany === this.defaultCompany || data.entry.cwCompany === '') {
      return(
        <div style={{ display: 'flex' }}>
        --
        </div>
      ) as VNode;
    }
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SwToggle
            value={data.entry.syncStatus}
            name="basicSwitch"
            disabled={
              data.entry.cwCompany === this.defaultCompany
              || data.entry.cwCompany === ''
            }
            onChange={() => {
              data.entry.syncStatus = !data.entry.syncStatus;
              this.saveTenantData(data.entry, 'syncStatus');
            }}
          />
          <span style={{ marginLeft: '1rem' }}>
            {this.$t('psaIntegration.disabled')}
          </span>
        </div>
    ) as VNode;
  }

  get syncDetails() {
    return this.$store.getters[`${storeName}/getSyncDetails`];
  }

  get serverDetailsFromStore() {
    return { ...this.$store.getters[`${storeName}/getCwServerDetails`] };
  }

  get isIntegrationConfigured() {
    if (this.serverDetailsFromStore.serverUrl === 'Not configured' || this.serverDetailsFromStore.serverUrl === '') {
      return true;
    }
    return false;
  }

  get basicData() {
    const tableData = this.$store.getters[`${storeName}/getTenantsData`];
    if (tableData.length > 0) {
      this.paginationConfig.pageNumber = this.searchTenant === '' ? this.tempPageNumber : 1;
      const filteredData = this.getSearchedTenent();
      // this.tableLoader = true;
      // this.debouncedLoadedPartialDataset();
      // this.nwAndMsspColEnabled = filteredData.some(t => t.msspProdCount && t.msspProdCount !== '' && t.networkProdCount && t.networkProdCount !== '');
      return filteredData;
    }
    // this.tableLoader = true;
    // this.debouncedLoadedPartialDataset();
    return tableData;
  }

  get debouncedLoadedPartialDataset() {
    return _.debounce(
      () => { this.tableLoader = false; },
      600,
    );
  }

  get tenantsData(): TableEntry[] {
    return this.basicData;
  }

  get isSubmitted() {
    return this.$store.getters[`${storeName}/getSubmitted`];
  }

  get responsiveLayoutUnit(): FlexLayoutUnit {
    if (this.isIntegrationConfigured) {
      this.totalBlocks = 4;
      this.blockPerLine = 4;
    } else  {
      this.totalBlocks = 5;
      this.blockPerLine = 5;
    }
    const rootUnit: FlexLayoutUnit = {
      id: 'root',
      container: {
        direction: 'column',
        justifyContent: 'start',
        alignItems: 'stretch',
        wrap: false,
        items: [],
        // wrap: true,
      },
    };
    const lines = Math.ceil(this.totalBlocks / this.blockPerLine);

    for (let i = 1; i <= lines; i += 1) {
      let rowUnit: FlexLayoutUnit = {
        id: `r${i}`,
        item: { flex: true },
        container: {
          direction: 'row',
          justifyContent: 'start',
          alignItems: 'start',
          items: [],
        },
      };
      if (this.isIntegrationConfigured) {
        rowUnit = {
          id: `r${i}`,
          item: { flex: true },
          container: {
            direction: 'row',
            justifyContent: 'start',
            alignItems: 'center',
            items: [],
          },
        };
      }
      rootUnit.container!.items.push(rowUnit);

      const blocks = i * this.blockPerLine > this.totalBlocks
        ? this.totalBlocks % this.blockPerLine
        : this.blockPerLine;

      for (let j = 1; j <= blocks; j += 1) {
        const count = (i - 1) * this.blockPerLine + j;
        const cellUnit: FlexLayoutUnit = {
          id: `${count}`,
          item: { flex: true },
          container: {
            justifyContent: 'start',
            alignItems: 'start',
            items: [],
          },
        };
        rowUnit.container!.items.push(cellUnit);
      }
    }
    return rootUnit;
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  renderTenantMatchMessage(tenantName: any, mode: string = 'company'): VueRenderFunction {
    let selectedTenants = tenantName;
    if (tenantName.length >= 5) {
      selectedTenants = `${tenantName.length} ${this.$t('activityLogs.tenants')}`;
    }
    let modeMsg = '';
    if (mode === 'company') {
      modeMsg = this.$t('psaIntegration.connectwiseManage.comapanyMsg1')
      .toString();
    } else if (mode === 'agreement') {
      modeMsg = this.$t('psaIntegration.connectwiseManage.agreementMsg1')
      .toString();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    /* tslint:disable-next-line */
    return (h: CreateElement) => (
      <div> {modeMsg} <span style="font-weight: 700"> {selectedTenants.toString()}. </span>  {this.$t('psaIntegration.dattoAutotask.contractmsg2')}  </div>
    ) as VNode;
  }

  displayModal() {
    this.displayConfigurationModal = true;
  }

  hideConfigurationModal() {
    this.displayConfigurationModal = false;
    if (this.isSubmitted || (this.$store.getters[`${storeName}/modalClosed`] === true)) {
      this.refreshData(true, false);
    }
  }

  // Filter Layout construct Starts
  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [
      [
        { title: String(this.$t('psaIntegration.syncEnabled')), content: this.viewSyncEnabledFilterRender, width: 250 },
        { title: String(this.$t('psaIntegration.agreementMapped')), content: this.viewAgreementsMappedFilterRender, width: 255 },
        { title: String(this.$t('psaIntegration.hasNWProds')), content: this.viewNetworkProdFilterRender, width: 255 },
        { title: String(this.$t('psaIntegration.hasMonthlyProds')), content: this.viewMonthlyProdFilterRender, width: 255 },
      ],
    ];
  }

  private viewSyncEnabledFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.syncFilters.map<VNode>((val: any) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
                  <SwRadio
                    {...{
                      props: {
                        name: val.label,
                        value: val.value,
                        pickedValue: this.syncSelectValue,
                      },
                      nativeOn: {
                        change: (event: any) => {
                          const clickedValue = event.target.value;
                          this.syncSelectValue = clickedValue;
                          this.applyFilter();
                        },
                      },
                    }}> { val.label } </SwRadio>
                </div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }

  private viewAgreementsMappedFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.agreementFilters.map<VNode>((val: any) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
                  <SwRadio
                    {...{
                      props: {
                        name: val.label,
                        value: val.value,
                        pickedValue: this.agreementSelectValue,
                      },
                      nativeOn: {
                        change: (event: any) => {
                          const clickedValue = event.target.value;
                          this.agreementSelectValue = clickedValue;
                          this.applyFilter();
                        },
                      },
                    }}> { val.label } </SwRadio>
                </div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }

  private viewNetworkProdFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.networkProdsFilters.map<VNode>((val: any) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
                  <SwRadio
                    {...{
                      props: {
                        name: val.label,
                        value: val.value,
                        pickedValue: this.networkProdSelectValue,
                      },
                      nativeOn: {
                        change: (event: any) => {
                          const clickedValue = event.target.value;
                          this.networkProdSelectValue = clickedValue;
                          this.applyFilter();
                        },
                      },
                    }}> { val.label } </SwRadio>
                </div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }

  private viewMonthlyProdFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.monthlyProdFilters.map<VNode>((val: any) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
                  <SwRadio
                    {...{
                      props: {
                        name: val.label,
                        value: val.value,
                        pickedValue: this.monthlyProdSelectValue,
                      },
                      nativeOn: {
                        change: (event: any) => {
                          const clickedValue = event.target.value;
                          this.monthlyProdSelectValue = clickedValue;
                          this.applyFilter();
                        },
                      },
                    }}> { val.label } </SwRadio>
                </div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }

  // For updating the table row details
  saveTenantData(updatedRow: any, operation: string) {
    this.$store
    .dispatch(`${storeName}/postTenantDetails`, updatedRow)
    .then(() => {
      if (operation !== 'mapping') {
        const infoMsg = `${this.$t('psaIntegration.connectwiseManage.msg8.submsg1')
        .toString()} ${updatedRow.tenantName} ${this.$t('psaIntegration.connectwiseManage.msg8.submsg2')
        .toString()}`;
        this.showMessage(infoMsg, 'success');
      }
      // this.fetchSyncDetails();
    })
    .catch((error) => {
      this.fetchSyncDetails(false);
      if (operation === 'mapping') {
        const infoMsg = `${this.$t('psaIntegration.connectwiseManage.msg7.submsg1')
        .toString()} ${updatedRow.tenantName} ${this.$t('psaIntegration.connectwiseManage.msg7.submsg3')
        .toString()}`;
        this.showMessage(infoMsg, 'failed');
      } else {
        const infoMsg = `${this.$t('psaIntegration.connectwiseManage.msg7.submsg2')
        .toString()} ${updatedRow.tenantName} ${this.$t('psaIntegration.connectwiseManage.msg7.submsg3')
        .toString()}`;
        this.showMessage(infoMsg, 'failed');
      }
      console.error(error);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  getSearchedTenent(): TableEntry[] {
    const tableData = [...this.$store.getters[`${storeName}/getTenantsData`]];
    let filteredValue: TableEntry[] = [];
    if (this.searchTenant.length > 1 && this.searchTenant.charAt(0) === '!') {
      const searchedWord = this.searchTenant?.slice(1) || '';
      if (searchedWord) {
        filteredValue = tableData.filter((obj: any) => {
          return !obj.tenantName.toLowerCase()
          .includes(searchedWord.toLowerCase());
        });
      }
    } else if (this.searchTenant.charAt(0) !== '!') {
      filteredValue = tableData.filter((obj: any) => obj.tenantName.toLowerCase()
      .includes(this.searchTenant.toLowerCase()));
    } else {
      filteredValue = tableData;
    }
    return filteredValue;
  }

  onChangePageNumber(data: PageNumberChangeRequestData) {
    this.paginationConfig.pageNumber = data.pageNumber;
    this.tempPageNumber = this.paginationConfig.pageNumber;
    this.debouncedLoadedPartialDataset();
  }

  onChangePageSizer(data: PageSizeChangeRequestData) {
    this.paginationConfig.pageSize = data.pageSize;
    this.paginationConfig.pageNumber = Math.min(
      this.paginationConfig.pageNumber,
      Math.ceil(this.tenantsData.length / this.paginationConfig.pageSize),
    );
    this.tempPageNumber = this.paginationConfig.pageNumber;
    this.debouncedLoadedPartialDataset();
  }

  async refreshData(enableLoading: boolean = true, refresh: boolean) {
    try {
      enableLoading && this.$store.commit('startLoading');
      await this.fetchIntegrationDetails();
      console.warn(this.loadOtherApis);
      if (this.loadOtherApis) {
        await this.fetchSyncJobStatus();
        await this.fetchTableDropdownValues();
        await this.fetchSyncDetails(refresh);
      }
      this.initiateSync = false;
      if (enableLoading) { this.$store.commit('stopLoading'); }
    } catch {
      if (enableLoading) { this.$store.commit('stopLoading'); }
    }
  }

  // Sync details for integration details and tenants table data
  async fetchSyncDetails(refreshed: boolean) {
    try {
      this.tableLoader = true;
      const result = await this.$store.dispatch(`${storeName}/getSyncDetails`, refreshed);
      if (result && result !== undefined && result !== {}) {
        this.$store.dispatch(`${storeName}/setSyncDetailsToStore`, result);
        this.allData = JSON.parse(JSON.stringify(result.tenants));
        await this.$store
        .dispatch(`${storeName}/getTenantSyncStatus`)
        // eslint-disable-next-line @typescript-eslint/no-shadow
        .then((result) => {
          const syncStatusList = result || [];
          if (syncStatusList.length === 0) {
            this.allData.forEach((data:any) => {
              data['syncDetails'] = {};
            });
          } else {
            if (syncStatusList.some((e:any) => e['tenant_name'] === 'generic_err')) {
              const genricSyncItem = syncStatusList.filter((e:any) => e['tenant_name'] === 'generic_err');
              syncStatusList.forEach((sList:any) => {
                sList['error_count'] = sList['error_count'] + genricSyncItem[0]['error_count'];
                sList['errors'] = [...sList['errors'], ...genricSyncItem[0]['errors']];
              });
            }
            this.allData.map((data:any) => syncStatusList.forEach((sList:any) => { if (sList['tenant_name'] === data['tenantName']) data['syncDetails'] = sList; }));
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status !== 404 && error.response.status !== 401) {
              const infoMsg: string = this.$t('psaIntegration.connectwiseManage.msg4')
              .toString();
              this.showMessage(infoMsg, 'failed');
              console.error(error);
            }
          }
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
        // console.warn(this.allData);
        // this.tenantsData = this.allData;
        this.$store.commit(`${storeName}/setTenantsData`, this.allData);
        this.$store.commit(`${storeName}/setTempTenantsData`, this.allData);
      }
      this.tableLoader = false;
      // this.cwCompanyOptions.unshift(this.initialCwCompanyOptions);
    } catch (error) {
      if (error?.response) {
        if (error?.response?.status !== 404 && error?.response?.status !== 401) {
          const infoMsg: string = this.$t('psaIntegration.dattoAutotask.msg2')
          .toString();
          this.showMessage(infoMsg, 'failed');
          console.error(error);
        }
      }
    } finally {
      this.$store.commit('stopLoading');
      this.tableLoader = false;

    }
  }

  // Table dropdown api's
  async fetchTableDropdownValues() {
    try {
      const req: any = {
        isForced: 'TRUE',
      };
      const result = await this.$store.dispatch(`${storeName}/getCompanyList`, req);
      this.cwCompanyOptions = result;
      // this.cwCompanyOptions.unshift(this.initialCwCompanyOptions);
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 404 && error.response.status !== 401) {
          const infoMsg: string = this.$t('psaIntegration.dattoAutotask.msg3')
          .toString();
          this.showMessage(infoMsg, 'failed');
          console.error(error);
        }
      }
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  // For config wizard api
  async fetchIntegrationDetails() {
    try {
      const result: any = await this.$store.dispatch(`${storeName}/fetchCwIntegrationDetails`);
      const intDetails: any = result;
      // this.syncDetails = result;
      // this.cwCompanyOptions.unshift(this.initialCwCompanyOptions);
      if (intDetails?.serverUrl && (intDetails?.serverUrl !== '')) {
        debugger;
        this.loadOtherApis = true;
      }
      if (!intDetails.hasOwnProperty('userList')) {
        intDetails['userList'] = [];
      } else {
        let userList: any = intDetails['userList'];
        if (typeof userList === 'string') {
          userList = this.convertStringToArrayOfObjects(userList);
          // console.warn(userList);
          intDetails['userList'] = userList;
        }
        const currentUser = JSON.parse(this.$store.getters.getUserInfo).user.email;
        if (userList.some((ele: any) => ele.userName === currentUser)) {
          this.disableConfigure = true;
        }
      }
      this.$store.commit(`${storeName}/setCwServerDetails`, intDetails);
      // this.$store.commit('PSAIntegrationStoreModule/saveServerDetails', result['integration_config']);
    } catch (error) {
      console.warn(error);
      if (error.response) {
        // if (error.response.status !== 404 && error.response.status !== 401) {
        //   const infoMsg = `${this.$t('psaIntegration.dattoAutotask.msg1')
        //   .toString()}`;
        //   this.showMessage(infoMsg, 'failed');
        // } else {
        this.showMessage(error?.response?.data?.message || this.$t('psaIntegration.dattoAutotask.msg1').toString(), 'failed');
        // }
      }
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  async syncNow() {
    this.initiateSync = true;
    await this.fetchSyncJobStatus();
    // await this.fetchTenantSyncStatus();
  }

  // Sync Operation Apis
  async fetchSyncJobStatus() {
    try {
      const result = await this.$store.dispatch(`${storeName}/getSyncJobStatus`);
      if (result.status === 'completed' || result.status === 'failed' || result.status === 'N/A') {
        this.showSyncStatusMessage = false;
        if (this.initiateSync) {
          await this.initiateSyncOperation();
          await this.fetchSyncDetails(false);
          await this.fetchTableDropdownValues();
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (result.status === 'created') {
          this.showSyncStatusMessage = true;
          this.syncStatusMesaage = `${this.$t('psaIntegration.dattoAutotask.msg4.submsg1')
          .toString()} ${result.time} ${this.$t('psaIntegration.dattoAutotask.msg4.submsg4')
          .toString()}`;
        } else if (result.status === 'started') {
          this.showSyncStatusMessage = true;
          this.syncStatusMesaage = `${this.$t('psaIntegration.dattoAutotask.msg4.submsg2')
          .toString()} ${result.time} ${this.$t('psaIntegration.dattoAutotask.msg4.submsg4')
          .toString()}`;
        } else if (result.status === 'queued') {
          this.showSyncStatusMessage = true;
          this.syncStatusMesaage = `${this.$t('psaIntegration.dattoAutotask.msg4.submsg3')
          .toString()} ${result.time} ${this.$t('psaIntegration.dattoAutotask.msg4.submsg4')
          .toString()}`;
        }
        // this.showMessage(`Could not initiate sync operation. An existing sync operation is in progress for last ${result.time}.`, 'failed');
      }
    } catch (error) {
      const infoMsg: string = this.$t('psaIntegration.connectwiseManage.msg2')
      .toString();
      this.showMessage(infoMsg, 'failed');
      console.error(error);
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  async initiateSyncOperation() {
    this.initiateSync = false;
    this.syncStatusMesaage = this.$t('psaIntegration.dattoAutotask.msg5')
    .toString();
    try {
      const result = await this.$store.dispatch(`${storeName}/startSyncNow`); // tslint:disable-line
      this.showSyncStatusMessage = true;
      this.$store.commit('stopLoading');
      const infoMsg: string = this.$t('psaIntegration.connectwiseManage.msg1')
      .toString();
      this.showMessage(infoMsg, 'success');
    } catch (error) {
      this.showSyncStatusMessage = false;
      this.$store.commit('stopLoading');
      const infoMsg: string = this.$t('psaIntegration.connectwiseManage.msg2')
      .toString();
      this.showMessage(infoMsg, 'failed');
      console.error(error);
    } finally {
      this.$store.commit('stopLoading');
    }
  }

  resetCwConfigSync() {
    confirmService.confirm({
      status: 'critical',
      title: String(this.$t('psaIntegration.connectwiseManage.resetData')),
      message: String(this.$t('psaIntegration.connectwiseManage.resetConfMsg')),
      buttons: [
        {
          key: 'cancel',
          name: this.$t('common.cancel')
          .toString(),
        },
        {
          key: 'ok',
          name: this.$t('common.confirm')
          .toString(),
          isDefault: true,
        },
      ],
    })
    .then((isConfirmed: any) => {
      if (isConfirmed === 'ok') {
        this.$store
        .dispatch(`${storeName}/resetConfigAndSync`)
        .then(async () => {
          this.$store.commit(`${storeName}/resetState`);
          await this.refreshData(true, false);
        })
        .catch((error) => {
          const infoMsg: string = this.$t('psaIntegration.connectwiseManage.resetFailed')
          .toString();
          this.showMessage(infoMsg, 'failed');
          console.error(error);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
      }
    });
  }

  gePSAtVersion() {
    this.$store
    .dispatch(`${storeName}/getPSAVersion`)
    .then((result:any) => {
      this.psaVersion = result?.content?.psaVersion || '';
      console.warn(result?.content);
      const custoMapping:boolean = result?.content?.isCustomCatalogEnabled && result?.content?.isCustomCatalogEnabled === 'Yes' ? true : false;
      this.$store.commit(`${storeName}/setShowCustomCatalogMapping`, custoMapping);
    })
    .catch((error:any) => {
      if (error.response) {
        if (error.response.status !== 404 && error.response.status !== 401) {
          const infoMsg: string = this.$t('psaIntegration.dattoAutotask.msg3')
          .toString();
          this.showMessage(infoMsg, 'failed');
          console.error(error);
        }
      }
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  async created() {
    this.gePSAtVersion();
    const tableData: any = this.$store.getters[`${storeName}/getTenantsData`];
    if (tableData.length === 0) {
      await this.refreshData(true, false);
    }
  }

  convertStringToArrayOfObjects(list: any) {
    let data = list.replace(/[[\]]/g, '');
    data = data.split(', {');
    const tempData: any = [];
    data.forEach((item: any, index: number) => {
      let currItem = item.replace(/'/g, '"');
      if (index > 0) {
        currItem = `{${currItem}`;
      }
      tempData.push(JSON.parse(currItem));
    });
    // console.warn(tempData);
    return tempData;
  }

  closeErrorLogDialog() {
    this.errorLogsModal = false;
  }

  // For toaster message
  showMessage(infoMsg: string, infoType: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }

  applyFilter() {
    const temptableData = this.$store.getters[`${storeName}/getTempTenantsData`];
    let filterData: TableEntry[] = _.cloneDeep(temptableData);
    switch (this.syncSelectValue) {
      case 'yes':
        filterData = filterData.filter((ele:any) => ele.syncStatus === true);
        break;
      case 'no':
        filterData = filterData.filter((ele:any) => ele.syncStatus === false);
        break;
      default:
        break;
    }
    switch (this.agreementSelectValue) {
      case 'yes':
        filterData = filterData.filter((ele:any) => ele.agreement !== this.defaultAgreement);
        break;
      case 'no':
        filterData = filterData.filter((ele:any) => ele.agreement === this.defaultAgreement);
        break;
      default:
        break;
    }
    switch (this.networkProdSelectValue) {
      case 'yes':
        filterData = filterData.filter((ele:any) => ele.networkProdCount && ele.networkProdCount !== '');
        break;
      case 'no':
        filterData = filterData.filter((ele:any) => ele.networkProdCount && ele.networkProdCount === '');
        break;
      default:
        break;
    }
    switch (this.monthlyProdSelectValue) {
      case 'yes':
        filterData = filterData.filter((ele:any) => ele.msspProdCount && ele.msspProdCount !== '');
        break;
      case 'no':
        filterData = filterData.filter((ele:any) => ele.msspProdCount && ele.msspProdCount === '');
        break;
      default:
        break;
    }
    // if (this.nwAndMsspColEnabled) {
    // }
    // this.filteredData = filterData;
    this.$store.commit(`${storeName}/setTenantsData`, filterData);
  }

  navigeteToHelp() {
    window.open('https://www.sonicwall.com/medialibrary/docs/tech-alliance/ConnectWise_PSA_IntegrationGuide.pdf', '_blank');
  }
}
